import React from 'react';

class LayerOrder extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      zIndex: props.layer.mapLayer.getZIndex()
    }
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e){
    const { layer } = this.props;
    let zIndex = layer.mapLayer.getZIndex();
    const {type} =e.currentTarget.dataset
    if(type=== 'add') {
      zIndex=zIndex+1;
    }else{
      zIndex=zIndex-1;
    }
    this.setState({zIndex}, layer.mapLayer.setZIndex(zIndex))
  }

  render(){
    const {layer} = this.props;
    const zIndex = layer.mapLayer.getZIndex();
    return (
      <div style={{display: 'block'}}>
        <hr/>
        <div style={{display:'flex'}}>
          
          <label className="control-label">Layer Order: { zIndex }</label>
          <button title="Push Layer to the Back" disabled={(zIndex === 0 ? true : false)} className="btn btn-sm" onClick={this.handleChange} style={{display:'flex', alignItems: 'center', marginLeft:'6px', color: '#444444', backgroundColor: '#ffffff'}} data-type="minus"><span className="glyphicon glyphicon-arrow-down"></span></button>
          <button title="Bring Layer to the Front" className="btn btn-sm" onClick={this.handleChange} style={{display:'flex', alignItems: 'center', marginLeft:'2px', color: '#444444', backgroundColor: '#ffffff'}} data-type="add"><span className="glyphicon glyphicon-arrow-up"></span></button>
        </div>
      </div>
    )
  }
}

export default LayerOrder;